import classNames from 'classnames';
import { IconChevronDown } from 'featherico';
import * as React from 'react';
import styles from './style.m.less';

type CustomProps = {
    isSmall?: boolean;
    hasError?: boolean;
    options?: {
        value: string;
        label: string;
    }[];
    placeholder?: string;
};

export default function SelectSimple({
    isSmall,
    className,
    hasError,
    children,
    options,
    placeholder,
    value,
    ...props
}: React.DetailedHTMLProps<React.SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement> & CustomProps) {
    return (
        <div
            className={classNames(styles.container, className, {
                [styles.isSmall]: isSmall,
            })}
        >
            <select
                className={classNames(styles.select, {
                    [styles.hasError]: hasError,
                })}
                value={!value && placeholder !== undefined ? 'placeholder' : value}
                {...props}
            >
                {options ? (
                    <>
                        {placeholder !== undefined && (
                            <option disabled value="placeholder">
                                {placeholder}
                            </option>
                        )}
                        {options.map(({ label, value: optionValue }) => (
                            <option key={optionValue} value={optionValue}>
                                {label}
                            </option>
                        ))}
                    </>
                ) : (
                    children
                )}
            </select>
            <IconChevronDown className={styles.icon} />
        </div>
    );
}

/**
 * A button that looks like a Select (mostly for the arrow).
 */
export function SelectSimpleButton({
    isSmall,
    className,
    hasError,
    type = 'button',
    ...props
}: React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> &
    Pick<CustomProps, 'isSmall' | 'hasError'>) {
    return (
        <div className={classNames(styles.container, className, { [styles.isSmall]: isSmall })}>
            <button type={type} className={classNames(styles.select, { [styles.hasError]: hasError })} {...props} />
            <IconChevronDown className={styles.icon} />
        </div>
    );
}
